import React from "react"
import { withRouteData, Link } from "react-static"
import Map from "components/Map"

import "./styles.css"

class Sites extends React.Component {
	state = {
		selectedSite: undefined
	}

	selectSite = site => this.setState({ selectedSite: site })
	unselectSite = () => this.setState({ selectedSite: undefined })

	render() {
		const { selectedSite } = this.state
		const mapProperties = {}
		if (selectedSite !== undefined)
			mapProperties.point = {
				coordinates: selectedSite.coordinates,
				title: selectedSite.name,
				description: selectedSite.description.substr(0, 255),
				url: `/site/show/${selectedSite.id}`
			}
		else
			mapProperties.points = this.props.sites.map(site => ({
				coordinates: site.coordinates,
				title: site.name,
				description: site.description.substr(0, 255),
				url: `/site/show/${site.id}`
			}))

		return (
			<div id="sites" className="grid-content">
				<div id="sites-list" className="card narrow">
					<h1>Research Sites</h1>
					<ul>
						{this.props.sites.map(site => (
							<li
								key={site.id}
								onMouseEnter={() => this.selectSite(site)}
								onMouseLeave={() => this.unselectSite()}
							>
								<Link to={`/site/show/${site.id}/`}>
									<h2>{site.name}</h2>
									<div className="meta">
										<div>
											<i uk-icon="location" />{" "}
											{site.siteType}
										</div>
										<div>
											{site.archiveTypes.length > 0 ? (
												<i uk-icon="tag" />
											) : (
												""
											)}{" "}
											{site.archiveTypes.join(", ")}
										</div>
									</div>
									<p>{site.description.substr(0, 255)}</p>
									<div className="projects">
										<i uk-icon="users" />{" "}
										{site.projects
											.map(p => p.toUpperCase())
											.join(", ")}
									</div>
								</Link>
							</li>
						))}
					</ul>
				</div>
				<Map id="sites-map" height="100%" {...mapProperties} />
			</div>
		)
	}
}

export default withRouteData(Sites)



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/containers/Sites/index.js